<template>
    <div>
        <v-dialog v-model="estatus" persistent  width="350">
            <div class="resaltar pa-6">
                <div class="d-flex justify-center"><strong>{{mensaje}}</strong></div>
                <v-progress-linear indeterminate color="primary" class="mt-3"></v-progress-linear>    
            </div>
        </v-dialog>
    </div>
</template>


<script>
export default {
    name: 'DialogoCarga',
    props:{
        mensaje: String,        
        estatus: Boolean
    },
    data() {
        return {
          
        }
    },
}
</script>